import DataLayerTracking from './DataLayerTracking';

DataLayerTracking();
